<template>
  <div>
    <el-card shadow="always">
      <div class="side-frame">
        <span style="font-size: 14px; color: #606266">客户账单基本信息</span>
      </div>
      <edit-form
        ref="editForm"
        :custStatementCode="params.custStatementCode"
        :disabled="isDisableEditForm"
        :isDisableParentCust="isDisableParentCust"
        :params="params"
        @codeChange="onCodeChange"
      />

      <div class="d-flex justify-content-end mb-2">
        <el-button
          v-if="!isDisableEditForm"
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          >保存</el-button
        >
      </div>

      <el-divider></el-divider>
      <div class="side-frame">
        <span style="font-size: 14px; color: #606266">客户账单明细</span>
      </div>
      <contact-table :code="params.custStatementCode" ref="contactTable" />
    </el-card>
  </div>
</template>
<script>
import ContactTable from './contact-table/index'
import EditForm from '../components/edit-form'

export default {
  name: 'finance-customerBill-detail',
  components: {
    EditForm,
    ContactTable,
  },
  data() {
    return {
      code: '',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
    // 是否禁用主客户
    isDisableParentCust() {
      return this.pageType === 'edit'
    },
  },
  mounted() {
    this.code = this.params.custStatementCode
  },
  methods: {
    onCodeChange(val) {
      this.code = val
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
